import Price from "../../records/Price"
import { Currency } from "@kiwicom/frontend-mmb/types/primitiveTypes"
import { ConvertPrice } from "../currencies/selectors"
import { convertPriceRecord } from "@kiwicom/frontend-mmb/scenes/AccountBooking/components/Booking/scenes/BookingPayment/services/helpers/helpers"

/**
 * Converts price to UI currency if UI isn't in EUR
 *
 * Helpful when converting Prices from backend which are always in EUR
 *
 * @param uiCurrency
 * @param convertPrice
 * @param price
 * @returns {Price}
 */
export default function maybeConvertPrice(
  uiCurrency: Currency,
  convertPrice: ConvertPrice,
  price: Price,
): Price {
  const shouldConvertPrices = price.currency === "eur" && uiCurrency !== "eur"
  return shouldConvertPrices ? convertPriceRecord(convertPrice, uiCurrency, price) : price
}
